import React, { useState } from 'react';
import api from '../api';
import { useTranslation } from '../LanguageContext';

function Contactus() {
    const { t } = useTranslation();
    const [message, setMessage] = useState("");
    const [subject, setSubject] = useState("");
    const [errors, setErrors] = useState([]);
    const [success, setSuccess] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors([]);
        setSuccess([]);
        try {
            const res = await api.post("/api/contact_us/", { message, subject });
            if (res.status === 200) {
                setMessage("");
                setSubject("");
                setSuccess([t('contact.successMsg')]);
            }
        }
        catch (error) {
            setErrors([error.response.data]);
        }
    };

    return (
        <div className="w-full mt-4 mb-8">
            <div className="card">
                <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                        <label className="label">{t('contact.subjectLabel')}</label>
                        <input
                            placeholder={t('contact.subjectPlaceholder')}
                            className="input"
                            type="text"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            maxLength={30}
                            required
                        />
                    </div>

                    <div>
                        <label htmlFor="message" className="label">{t('contact.messageLabel')}</label>
                        <textarea
                            type="text"
                            required
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="input min-h-[120px] resize-y"
                            id="message"
                            rows="5"
                            placeholder={t('contact.messagePlaceholder')}
                        />
                    </div>

                    {errors.length > 0 && (
                        <ul className="list-none p-0 space-y-1">
                            {errors.map((error, index) => (
                                <li key={index} className="text-sm text-red-600">{` ${error}`}</li>
                            ))}
                        </ul>
                    )}
                    {success.length > 0 && (
                        <ul className="list-none p-0 space-y-1">
                            {success.map((msg, index) => (
                                <li key={index} className="text-sm text-emerald-600">{` ${msg}`}</li>
                            ))}
                        </ul>
                    )}

                    <button type="submit" className="btn-secondary">
                        {t('contact.sendBtn')}
                    </button>
                </form>
            </div>
        </div>
    )
}
export default Contactus;